let keyboardFocus = false;
let currentStickyBlock = null;

const TOP_OFFSET = 70;

function getScrollBehavior() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'instant'
    : 'smooth';
}

function scrollIfUnderHeader(element) {
  const { top } = element.getBoundingClientRect();

  if (top >= TOP_OFFSET) {
    return;
  }

  window.scrollBy({ top: top - TOP_OFFSET, behavior: getScrollBehavior() });
}

function findStickyBlock(element) {
  const section = element.closest('main section');

  if (!section) {
    return null;
  }

  if (window.getComputedStyle(section).position === 'sticky') {
    return section;
  }

  return null;
}

function getNextBlock(stickyBlock) {
  const main = stickyBlock.closest('main');

  if (!main) {
    return null;
  }

  const sections = [...main.querySelectorAll('section')];
  const stickyIndex = sections.indexOf(stickyBlock);

  if (stickyIndex === -1 || stickyIndex >= sections.length - 1) {
    return null;
  }

  return sections[stickyIndex + 1];
}

function scrollNextBlockBelowSticky(stickyBlock, nextBlock) {
  const offset = stickyBlock.getBoundingClientRect().bottom
    - nextBlock.getBoundingClientRect().top;

  if (offset <= 0) {
    return;
  }

  window.scrollBy({ top: -offset, behavior: getScrollBehavior() });
}

function handleFocusChange(target) {
  if (!target || !(target instanceof Element)) {
    currentStickyBlock = null;
    return;
  }

  const stickyBlock = findStickyBlock(target);

  if (!stickyBlock) {
    currentStickyBlock = null;
    return;
  }

  if (currentStickyBlock === stickyBlock) {
    return;
  }

  const nextBlock = getNextBlock(stickyBlock);

  if (!nextBlock) {
    return;
  }

  currentStickyBlock = stickyBlock;
  scrollNextBlockBelowSticky(stickyBlock, nextBlock);
}

function initStickyFocusReveal() {
  const main = document.querySelector('main');

  if (!main) {
    return;
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      keyboardFocus = true;
    }
  });

  document.addEventListener('mousedown', () => {
    keyboardFocus = false;
  });

  main.addEventListener('focusin', (event) => {
    if (!keyboardFocus || !(event.target instanceof Element)) {
      return;
    }

    scrollIfUnderHeader(event.target);

    requestAnimationFrame(() => {
      handleFocusChange(event.target);
    });
  });

  main.addEventListener('focusout', () => {
    if (!keyboardFocus) {
      return;
    }

    requestAnimationFrame(() => {
      handleFocusChange(document.activeElement);
    });
  });
}

export default initStickyFocusReveal;
